import { createToObject } from 'pricing-pages-lib/utils/queryParamUtils';
import { Redirect } from 'react-router-dom';
import { FREE } from 'self-service-api/constants/ProductLevels';
import LoadingScreen from '../components/LoadingScreen';
import { useCompanyDetails } from '../hooks/useCompanyDetails';
import { useRecommendedRouting } from '../hooks/useRecommendations';
import { useAppSelector } from '../reducers';
import { isUngatedForSeatsSelector } from '../selectors/GatingSelectors';
import { useCrmSuiteOwnershipLevel, useIsFreePortal } from '../v2/hooks/inventory/useProductInventory';
import { jsx as _jsx } from "react/jsx-runtime";
export const DefaultInAppRoute = () => {
  const {
    recommendedRoute,
    loading: isLoadingRecommendedRoute
  } = useRecommendedRouting();
  const {
    loading: isCompanyDetailsLoading,
    isVSBPortal
  } = useCompanyDetails();
  const isUngatedForSeats = useAppSelector(isUngatedForSeatsSelector);
  const {
    crmSuiteLevel: ownedSuiteProductLevel
  } = useCrmSuiteOwnershipLevel();
  const {
    isFreePortal,
    loading: isInventoryLoading
  } = useIsFreePortal();
  const isFreeVSBPortal = isVSBPortal && isFreePortal;
  const ownsSuiteProduct = isUngatedForSeats && ownedSuiteProductLevel && ownedSuiteProductLevel !== FREE;
  if (isLoadingRecommendedRoute || isCompanyDetailsLoading || isInventoryLoading) {
    return /*#__PURE__*/_jsx(LoadingScreen, {});
  }
  if (isFreeVSBPortal) {
    return /*#__PURE__*/_jsx(Redirect, {
      from: "/",
      exact: true,
      to: createToObject('/crm')
    });
  }
  if (ownsSuiteProduct) {
    return /*#__PURE__*/_jsx(Redirect, {
      from: "/",
      exact: true,
      to: createToObject('/suite')
    });
  }
  return /*#__PURE__*/_jsx(Redirect, {
    from: "/",
    exact: true,
    to: createToObject(`/${recommendedRoute}`)
  });
};